// ======================================================================
// FILE:
// src/modules/finance/services/trialBalanceService.js
//
// MODULE:
// Finance & Accounts Management System (FBAMS)
//
// FEATURE:
// Trial Balance
//
// PURPOSE:
// Frontend API client for Trial Balance report.
//
// IMPORTANT:
// - API calls only
// - No React code
// - No UI logic
// - No navigation
// ======================================================================

import axiosClient
    from "../../../api/axiosClient";


// ======================================================================
// BASE URL
// ======================================================================

const BASE_URL =
    "/api/finance/reports/trial-balance";


// ======================================================================
// GET TRIAL BALANCE
// ======================================================================

async function getTrialBalance(
    params = {}
) {

    const response =
        await axiosClient.get(
            BASE_URL,
            {
                params,
            }
        );

    return response.data.data;
}


// ======================================================================
// EXPORT
// ======================================================================

const trialBalanceService = {

    getTrialBalance,

};

export default trialBalanceService;